<div class="d-flex flex-column h-100 w-100" style="min-height: 0">
  <app-grid
    *ngIf="!isLoading"
    [gridUid]="'routing_plans_tasks'"
    [gridOptions]="gridOptions"
    class="ag-theme-alpine flex-grow-1"
    style="width: 100%; min-height: 0; height: 100%"
    [rowData]="items"
    [autoGroupColumnDef]="tasksGridAutoGroupColumnDef"
  >
  </app-grid>
  <div *ngIf="isLoading" class="row flex-grow-1 h-100">
    <div class="col-12 h-100 d-flex align-items-center justify-content-center">
      <app-loader></app-loader>
    </div>
  </div>
</div>
